export const STATUS = {
    pending: 'pending',
    queued: 'queued',
    running: 'running',
    pendingReview: 'pending_review',
    completed: 'completed',
    cancelled: 'cancelled',
    failed: 'failed',
}

export const PHASES = {
    VALIDATION: 'validation',
    MERGING: 'merging',
}

export const SOURCES = {
    PREQUIN: 'preqin',
    QREPORTS: 'qreports',
    EXCELLOW: 'excellow',
    EXCELHIGH: 'excelhigh',
    COMPUTED: 'computed',
    MANUAL: 'manual',
    MULTI_ENTITY: 'multi-entity',
    OCR_STACKAI: 'ocr-stackai',
}

export const SOURCES_DISCARD = [
    SOURCES.COMPUTED,
    SOURCES.MANUAL,
    SOURCES.OCR_STACKAI,
]

// Sources that don't require selecting a specific entity type
// (they handle entity detection internally)
export const SOURCES_WITHOUT_ENTITIES = [
    SOURCES.PREQUIN,
    SOURCES.COMPUTED,
    SOURCES.MULTI_ENTITY,
    SOURCES.OCR_STACKAI,
]

export default {
    STATUS,
    SOURCES,
    SOURCES_DISCARD,
    SOURCES_WITHOUT_ENTITIES,
}
